import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class EmailIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><path d="M1 0h14a1 1 0 0 1 1 1v2L8 7 0 3V1a1 1 0 0 1 1-1zM0 4l8 4 8-4v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z"/></svg>
        )
    }
}

export default withCssClassName(EmailIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/email-icon.js